<template>
  <div :class="[classes.headerWrapper, 'header', layoutClass]">
    <HeaderOffer v-if="displayOffer" />
    <component :is="logoComponent" :class="classes.logo" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, defineAsyncComponent } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";
import { injectAdTag } from "@fresh8/ad-data-composition/src/brand";
import OperatorLogo from "./OperatorLogo.vue";
import HeaderOffer from "./HeaderOffer.vue";
import { injectLayout, STRAPLINE } from "../hooks/useLayout";

const useStyles = createUseStyles({
  headerWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    paddingBottom: "5px",
    [`&.${STRAPLINE}`]: {
      paddingBottom: "3px",
      justifyContent: "center"
    }
  },
  logo: {
    display: "flex",
    maxWidth: "125px",
    maxHeight: "21px",
    justifyContent: "flex-end",
    [`.${STRAPLINE} &`]: {
      justifyContent: "center"
    }
  }
});
export default defineComponent({
  name: "Header",
  components: {
    OperatorLogo,
    HeaderOffer
  },
  setup() {
    const { layout } = injectLayout();
    const { operators } = injectAdTag();
    const classesRef = useStyles();

    const logoComponent = computed(() => {
      return operators.value?.length > 1
        ? defineAsyncComponent(() => import("./OperatorSelector.vue"))
        : defineAsyncComponent(() => import("./OperatorLogo.vue"));
    });

    return {
      classes: classesRef.value,
      layoutClass: layout,
      displayOffer: computed(() => layout.value !== STRAPLINE),
      logoComponent
    };
  }
});
</script>

<style></style>
